import _objectSpread from "/Users/shorlyn/Documents/project/core/campus-all/rccms-web/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.reduce.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.for-each.js";
import "core-js/modules/es.iterator.reduce.js";
import "core-js/modules/es.json.stringify.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import Cookies from 'js-cookie';
import variables from '@/styles/element-variables.scss';
import defaultSettings from '@/settings';
var sideTheme = defaultSettings.sideTheme,
  showSettings = defaultSettings.showSettings,
  topNav = defaultSettings.topNav,
  tagsView = defaultSettings.tagsView,
  fixedHeader = defaultSettings.fixedHeader,
  sidebarLogo = defaultSettings.sidebarLogo,
  dynamicTitle = defaultSettings.dynamicTitle;
var storageSetting = JSON.parse(localStorage.getItem('layout-setting')) || '';
var userPreferencesKeyPrefix = 'rccms-user-ui-preferences';
var defaultUserPreferences = {
  filterOverlay: false
};
function getUserPreferencesKey(userId) {
  return "".concat(userPreferencesKeyPrefix, ":").concat(userId);
}
function loadStoredUserPreferences(userId) {
  if (!userId) return _objectSpread({}, defaultUserPreferences);
  try {
    return _objectSpread(_objectSpread({}, defaultUserPreferences), JSON.parse(localStorage.getItem(getUserPreferencesKey(userId))) || {});
  } catch (error) {
    return _objectSpread({}, defaultUserPreferences);
  }
}
var state = _objectSpread({
  title: '',
  theme: storageSetting.theme || variables.theme,
  sideTheme: storageSetting.sideTheme || sideTheme,
  showSettings: showSettings,
  topNav: storageSetting.topNav === undefined ? topNav : storageSetting.topNav,
  tagsView: storageSetting.tagsView === undefined ? tagsView : storageSetting.tagsView,
  fixedHeader: storageSetting.fixedHeader === undefined ? fixedHeader : storageSetting.fixedHeader,
  sidebarLogo: storageSetting.sidebarLogo === undefined ? sidebarLogo : storageSetting.sidebarLogo,
  dynamicTitle: storageSetting.dynamicTitle === undefined ? dynamicTitle : storageSetting.dynamicTitle
}, defaultUserPreferences);
var mutations = {
  CHANGE_SETTING: function CHANGE_SETTING(state, _ref) {
    var key = _ref.key,
      value = _ref.value;
    if (state.hasOwnProperty(key)) {
      state[key] = value;
      Cookies.set(key, value);
    }
  },
  LOAD_USER_PREFERENCES: function LOAD_USER_PREFERENCES(state, preferences) {
    Object.keys(defaultUserPreferences).forEach(function (key) {
      state[key] = preferences[key] === undefined ? defaultUserPreferences[key] : preferences[key];
    });
  },
  CHANGE_USER_PREFERENCE: function CHANGE_USER_PREFERENCE(state, _ref2) {
    var key = _ref2.key,
      value = _ref2.value;
    if (defaultUserPreferences.hasOwnProperty(key)) {
      state[key] = value;
    }
  }
};
var actions = {
  changeSetting: function changeSetting(_ref3, data) {
    var commit = _ref3.commit;
    commit('CHANGE_SETTING', data);
  },
  loadUserPreferences: function loadUserPreferences(_ref4, userId) {
    var commit = _ref4.commit;
    commit('LOAD_USER_PREFERENCES', loadStoredUserPreferences(userId));
  },
  changeUserPreference: function changeUserPreference(_ref5, data) {
    var commit = _ref5.commit,
      state = _ref5.state,
      rootState = _ref5.rootState;
    commit('CHANGE_USER_PREFERENCE', data);
    var userId = rootState.user.userId;
    if (!userId) return;
    var preferences = Object.keys(defaultUserPreferences).reduce(function (result, key) {
      result[key] = state[key];
      return result;
    }, {});
    localStorage.setItem(getUserPreferencesKey(userId), JSON.stringify(preferences));
  },
  resetUserPreferences: function resetUserPreferences(_ref6) {
    var commit = _ref6.commit;
    commit('LOAD_USER_PREFERENCES', _objectSpread({}, defaultUserPreferences));
  }
};
export default {
  namespaced: true,
  state: state,
  mutations: mutations,
  actions: actions
};